import VisitInformation from 'src/components/ConnectedVehicle/VisitInformation/VisitInformation';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';

const mapStateToProps = (state: IStoreState) => ({
    connectedVehicle: state.ConnectedVehicle.ConnectedVehicleRec,
});

export default connect(mapStateToProps)(VisitInformation);